import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { FIXTURE_MODE } from "@/lib/fixtureMode";
import { captureInviteToken } from "@/lib/invitation";

// Local visual test mode only (see lib/fixtureMode.js); a production build contains no fixtures.
if (process.env.NODE_ENV === "development" && FIXTURE_MODE) require("@/dev/v3Fixtures").installFixtures();

// /einladung#token=…: read and remove the fragment before the router or anything else sees the address.
captureInviteToken(window.location, window.history, document);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
